import { render, staticRenderFns } from "./ToPublish.vue?vue&type=template&id=ba9d3b88&"
import script from "./ToPublish.vue?vue&type=script&lang=js&"
export * from "./ToPublish.vue?vue&type=script&lang=js&"
import style0 from "./ToPublish.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ToPublish.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports